"use strict";

import QuestionCookieService from "./QuestionCookieService";
import {PhotoService} from "@/services/question/PhotoService";
import {QuestionWebSocketService} from "@/services/question/QuestionWebSocketService";

export const SURVEY_TYPE_PLANNER = 'planner';
export const SURVEY_TYPE_MECHANIC = 'mechanic';

export var questionCookieService = new QuestionCookieService();
export var photoService = new PhotoService();
export var webSocketService = new QuestionWebSocketService();